import React from 'react'
//import Todo from './todo/Todo'
//import Visual from './Visual'
import TodoApp from './react-todo/TodoApp';
//import PieChart from './PieChart'

const Home = () => (
  <div>
    <h2>Home</h2>
    <TodoApp />
  </div>
)

export default Home



/** WEBPACK FOOTER **
 ** ./src/Home.js
 **/